import { Request as request } from "@/utils/request"

export const fetchShareDomain = () => {
  return request("/api/common/fetch-share-domain", {
    method: "GET",
  });
};